<template>
  <div class="crm-card">
    <!-- Card header: filters + actions -->
    <div class="crm-card__header">
      <slot name="headers"></slot>
    </div>

    <!-- Table -->
    <div class="crm-card__body">
      <div class="table-responsive">
        <table class="table table-hover crm-table">
          <thead>
            <tr>
              <th v-for="header in headers" :key="header.field">
                {{ header.label }}
              </th>
            </tr>
          </thead>

          <soft-spinner v-show="spinner" />

          <tbody v-if="!spinner">
            <tr v-for="item in items" :key="item.id">
              <td v-for="fields in headers" :key="fields.field">
                <slot name="columnRender" :header="fields" :value="item">
                  {{ item[fields.field] }}
                </slot>
              </td>
            </tr>
            <tr v-if="!items || items.length === 0">
              <td :colspan="headers.length" class="crm-table__empty">
                <i class="fas fa-inbox mb-2 d-block" style="font-size:1.5rem; color:#CBD5E1"></i>
                No hay registros disponibles
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="!spinner" class="crm-card__pagination">
        <slot name="pagination"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import SoftSpinner from '@/components/SoftSpinner.vue'

export default {
  name: 'tableComponent',
  components: { SoftSpinner },
  props: {
    headers: {
      type: Array,
      required: true,
      validator: (v) => v.every((h) => 'field' in h && 'label' in h),
    },
    items: { type: [Array, Object], required: true },
    spinner: { type: Boolean, default: false },
    name: { type: String },
  },
}
</script>

<style scoped>
.crm-card {
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  overflow: hidden;
}

.crm-card__header {
  padding: 20px 24px 16px;
  border-bottom: 1px solid #F1F5F9;
}

.crm-card__body {
  padding: 0;
}

.crm-card__pagination {
  padding: 12px 16px;
  border-top: 1px solid #F1F5F9;
}

/* Table */
.crm-table {
  margin: 0;
  border-collapse: separate;
  border-spacing: 0;
}

.crm-table thead th {
  background: #F8FAFC;
  color: #475569;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  padding: 11px 14px;
  white-space: nowrap;
  border-bottom: 1px solid #E2E8F0;
  border-top: none;
}

.crm-table tbody tr {
  transition: background 0.1s ease;
}

.crm-table tbody tr:hover {
  background: #EFF6FF;
}

.crm-table td {
  padding: 10px 14px;
  vertical-align: middle;
  font-size: 0.82rem;
  color: #334155;
  border-bottom: 1px solid #F1F5F9;
}

.crm-table tbody tr:last-child td {
  border-bottom: none;
}

.crm-table__empty {
  text-align: center;
  padding: 40px 20px !important;
  color: #94A3B8;
  font-size: 0.85rem;
}
</style>
